export const SUBMIT_EMPLOYEE_SECTION_QUESTIONNAIRE_SUCCESS = "SUBMIT_EMPLOYEE_SECTION_QUESTIONNAIRE_SUCCESS";
export const LOAD_EMPLOYEE_PPQ_QUESTIONNAIRE = "LOAD_EMPLOYEE_PPQ_QUESTIONNAIRE";
export const LOAD_PPQ_REPORT = "LOAD_PPQ_REPORT";
export const LOAD_PPQ_REPORT_SUCCESS = "LOAD_PPQ_REPORT_SUCCESS";
export const VIEWED_PPQ_REPORT = "VIEWED_PPQ_REPORT";
